export default __webpack_public_path__ + "static/media/cad-flag.00003d13.svg";